import React, { useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faReact,
  faHtml5,
  faCss3,
  faJs,
  faVuejs,
  faLaravel,
  faPhp,
} from "@fortawesome/free-brands-svg-icons";
import CustomHook from "./CustomHook";

function Skills() {
  const divs = useRef([]);
  const scrollTab = useRef();
  CustomHook(scrollTab, divs);
  const [listSkills] = useState([
    {
      name: "HTML",
      des: "Skilled in using HTML to structure and organize content effectively, ensuring a strong foundation for web development.",
      icon: faHtml5,
    },
    {
      name: "CSS",
      des: "Proficient in CSS for designing visually appealing and responsive layouts, enhancing user experience across various devices.",
      icon: faCss3,
    },
    {
      name: "Javascript",
      des: "Experienced in JavaScript to create dynamic and interactive features, bringing websites to life with smooth functionality.",
      icon: faJs,
    },
    {
      name: "ReactJs",
      des: "Skilled in ReactJS for building reusable components and creating seamless user interfaces with modern front-end technologies.",
      icon: faReact,
    },
    {
      name: "Php",
      des: "Proficient in PHP for server-side scripting, enabling the development of dynamic and secure web applications.",
      icon: faPhp,
    },
    {
      name: "Laravel",
      des: "Experienced in Laravel for building robust, scalable, and feature-rich web applications with clean and maintainable code",
      icon: faLaravel,
    },
  ]);
  return (
    <section className="skills" ref={scrollTab}>
      <div className="title" ref={(el) => el && divs.current.push(el)}>
        This is my Skills
      </div>
      <div className="des" ref={(el) => el && divs.current.push(el)}>
        {/* 20 */}
        Showcasing a diverse range of skills in programming, front-end
        development, and video editing, each honed to deliver creative and
        impactful digital solutions.
      </div>
      <div className="list">
        {listSkills.map((value, key) => (
          <div
            className={"item "}
            key={key}
            ref={(el) => el && divs.current.push(el)}
          >
            <FontAwesomeIcon icon={value.icon} />
            <h3>{value.name}</h3>
            <div className="des">{value.des}</div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Skills;
